import { Controller } from "@hotwired/stimulus"

// Find a time, in "For you" on someone's page (ProfileTimesController): load
// the owner's free half-hours, then ask for one. The ask lands in the
// owner's Needs you with your email so they can confirm - nothing is booked.
export default class extends Controller {
  static targets = ["show", "slots", "status"]
  static values = { url: String }

  async load(event) {
    event.preventDefault()
    this.showTarget.disabled = true
    this._say("Looking at the calendar…")
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      const data = await response.json()
      const slots = data.slots || []
      if (!slots.length) {
        this._say("No free half-hours in the next week. Leave a message instead.")
        return
      }
      this.slotsTarget.replaceChildren(...slots.map((slot) => this._slot(slot)))
      this.slotsTarget.hidden = false
      this.showTarget.hidden = true
      this._say("Pick one to ask for it.")
    } catch (_error) {
      this._say("Couldn't load the free times. Try again later.")
    } finally {
      this.showTarget.disabled = false
    }
  }

  async ask(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.slotsTarget.querySelectorAll("button").forEach((b) => (b.disabled = true))
    this._say("Asking…")
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content },
        body: JSON.stringify({ starts_at: button.dataset.startsAt })
      })
      const data = await response.json().catch(() => ({}))
      if (response.ok && data.ok) {
        this.slotsTarget.hidden = true
        this._say(`Asked for ${button.textContent}. You'll hear back by email.`)
      } else {
        this._say(data.error || "That didn't go through. Try another time.")
        this.slotsTarget.querySelectorAll("button").forEach((b) => (b.disabled = false))
      }
    } catch (_error) {
      this._say("That didn't go through. Try again.")
      this.slotsTarget.querySelectorAll("button").forEach((b) => (b.disabled = false))
    }
  }

  _slot(slot) {
    const li = document.createElement("li")
    const button = document.createElement("button")
    button.type = "button"
    button.className = "btn btn-sm btn-outline-primary"
    button.textContent = slot.label
    button.dataset.startsAt = slot.starts_at
    button.dataset.action = "find-time#ask"
    li.appendChild(button)
    return li
  }

  _say(text) {
    this.statusTarget.textContent = text
  }
}
